import { LoadingSpinner } from '~/components/component-library/LoadingSpinner'

export const ToastLoadingIcon = () => {
  return <LoadingSpinner size="xl" thickness="thin" variant="black" />
}
